export const API_URL = 'https://my-json-server.typicode.com/asaddam/cinema'